<template>
  <div class="remark-table" style="min-width: 400px">
    <template v-if="!ifInternational?.()">
      <div class="remark-error" v-if="error">无退改签信息</div>
      <table v-else>
        <tbody>
          <tr>
            <td>时限</td>
            <td v-for="(change, changeIndex) in ruleInner.change" :key="'td' + change.takeoffFrom">
              <template v-if="changeIndex === 0">离站时间前{{ -change.takeoffFrom }}小时( 不含 )以内至航班起飞后</template>
              <template v-else-if="changeIndex === (ruleInner.change.length - 1)">离站时间前{{ -change.takeoffTo }}小时( 含 )以外</template>
              <template v-else>离站时间前{{ -change.takeoffTo }}小时( 含 )至{{ -change.takeoffFrom }}小时( 不含 )</template>
            </td>
          </tr>
          <tr>
            <td>变更费（每次）</td>
            <td v-for="change in ruleInner.change" :key="change.takeoffFrom">
              {{ (change.changeRefundDesc || change[name]) | ruleFee('免收变更费（每次）', name) }}
            </td>
          </tr>
          <tr>
            <td>退票费</td>
            <td v-for="refund in ruleInner.refund" :key="refund.takeoffFrom">
              {{ (refund.changeRefundDesc || refund[name]) | ruleFee('免收退票费', name) }}
            </td>
          </tr>
          <tr>
            <td>签转</td>
            <td v-for="signed in ruleInner.signed" :key="signed.takeoffFrom">
              {{ signed.canTran ? '允许' : '不允许' }}
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-else>
      <div class="refund-changes-detail-int" v-html="getRefundChangeFeesInt(seg)"></div>
    </template>
  </div>
</template>

<script>

export default {
  name: 'remark-table',
  props: {
    rule: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isJJC: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    name: {
      type: String,
      default: 'amount'
    }
  },
  computed: {
    error () {
      return !this.ruleInner.change || !this.ruleInner.refund || !this.ruleInner.signed
    }
  },
  inject: {
    ifInternational: {
      value: 'ifInternational',
      default: null
    }
  },
  watch: {
    rule: {
      handler (newRule) {
        let _rule = JSON.parse(JSON.stringify(newRule))
        let _ruleSort = {}

        if (!this.ruleInner.change || !this.ruleInner.refund || !this.ruleInner.signed) {
          _ruleSort.change = _rule.change.sort((r, nr) => {
            return +r.takeoffFrom < +nr.takeoffFrom
          })
          _ruleSort.refund = _rule.refund.sort((r, nr) => {
            return +r.takeoffFrom < +nr.takeoffFrom
          })
          _ruleSort.signed = _rule.signed.sort((r, nr) => {
            return +r.takeoffFrom < +nr.takeoffFrom
          })
        }

        this.ruleInner = _ruleSort
      },
      immediate: true
    }
  },
  data () {
    return {
      ruleInner: {}
    }
  },
  created () {

  },
  methods: {
    getRefundChangeFeesInt (seg) {
      return seg.intTicketRuleText?.replaceAll('\n', '<br>')
    }
  }
}
</script>

<style lang="less">
  .remark-table {
    table {
      text-align: center;
      width: 100%;
      font-size: 12px;
      border: 1px solid #808080;
    }

    tr {
      border: 1px solid #808080;

      td {
        border: 1px solid #808080;
        padding: 8px 4px;
        vertical-align: middle;
        width: 20px;
      }
    }
  }
</style>
